<template lang="pug">
  .whatsapp-forms
    .background-header.white
      v-container.white.pb-1(style="max-width:600px")
        div.my-2.mx-2
          v-text-field(v-model="searchText" placeholder='Search' hide-details dense outlined height="40" background-color="basic200")
            template(v-slot:append)
              eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
        div.my-2.mx-2(v-if="member.role === 'Admin'")
          v-btn.s1.text-capitalize.px-0(color="textColorAccent" text @click="clickAddForm")
            eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
            | {{ $t('create_new_sales_page') }}

    v-container.pa-0.mb-4(style="max-width:600px")
      //- FETCHING
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      //- EMPTY FORM
      .contain-layout.mx-2(v-else)
        template(v-if="forms.length == 0")
          div(align="center")
            p.c1 {{ $t('start_creating_sales_page') }}
            p.s2(align='center' justify='center') {{ $t('demo_page_below') }}:
            iframe.mt-3(src="https://yzza.io/jy7ll" title="Example Sales Page" :width="iframeWidth" :height="iframeHeight" frameborder="0")

        //- FORM LIST
        template(v-else)
          v-divider.basic300
          template(v-for="(form, index) in completedForm")
            landing-item(:key="form.id" :parentForm.sync="form" :statusd="statusDisable" :company="company" :reachFormCountLimit="reachFormCountLimit" @deleted="handleDeleteItem" @statusChange="fetchPublishedFormCount" @edited="handleEditItem" @duplicated="handleDuplicateItem" @openSubscription="openSalesPageSubscription = true")
            v-divider.basic300

      //- FORM IN PROGRESS
      div.mx-4(v-if="inProgressForm.length > 0")
        div.s2.primary400--text.mt-6.text-uppercase {{ $t('pages_in_progress') }}
        template(v-for="(form, index) in inProgressForm")
          landing-item-progress(:key="form.id" :parentForm.sync="form" @deleted="handleDeleteItem" :company="company" @edited="handleEditItem")

      y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="count")

    .modals
      add-landing-form(v-if="showAddWaFormDialog" :open.sync="showAddWaFormDialog" :company="company" @refresh="fetchForms(1)")
      sales-page-subscription(v-if="openSalesPageSubscription" :open.sync="openSalesPageSubscription" :company="company")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import AddLandingForm from '@/components/dialogs/landingform/AddLandingForm.vue'
import SalesPageSubscription from '@/components/dialogs/landingform/SalesPageSubscription.vue'
import LandingItem from '@/components/landingform/LandingItem.vue'
import LandingItemProgress from '@/components/landingform/LandingItemProgress.vue'

export default {
  name: 'LandingPages',
  components: { AddLandingForm, SalesPageSubscription, LandingItem, LandingItemProgress },
  props: ['company'],
  data: () => ({
    isFetching: false,
    showAddWaFormDialog: false,
    openSalesPageSubscription: false,
    isTyping: false,
    selectedStyle: 0,
    fetchCount: 10,
    page: 1,
    // totalPage: 1,
    searchText: '',
    forms: [],
    totalCount: 0,
    count: 0,
    searchCountDown: null,
    publishedFormCount: 0,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('subscriptions', ['yezzaSubscription']),
    reachFormCountLimit () {
      if (this.Auth('component', '/admin/landing-pages#landing_page_action')) {
        return Boolean(this.publishedFormCount >= this.yezzaSubscription.limitations.salespage || this.totalCount >= this.yezzaSubscription.limitations.salespage)
      } else {
        return Boolean(this.forms.length >= 3)
      }
    },
    iframeWidth () {
      if (screen.width < 600) {
        return screen.width - 40
      }
      return 560
    },
    iframeHeight () {
      if (screen.width < 600) {
        return window.innerHeight - 250
      }
      return window.innerHeight - 480
    },
    inProgressForm () {
      if (this.forms.length > 0) {
        return this.forms.filter(f => f.members.length === 0 || f.products.length === 0)
      }
      return []
    },
    completedForm () {
      if (this.forms.length > 0) {
        return this.forms.filter(f => f.members.length > 0 && f.products.length > 0)
      }
      return []
    },
    statusDisable () {
      return Boolean(this.publishedFormCount >= this.yezzaSubscription.limitations.salespage)
    }
  },
  mounted () {
    this.fetchPublishedFormCount()
    if (!this.$route.query.page) {
      this.fetchForms(1)
    } else {
      this.fetchForms(this.$route.query.page)
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        if (this.searchText) {
          this.searchItem(val)
        } else {
          this.fetchForms(val)
        }
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem(1)
      }, 500)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForms(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/forms/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id&type=whatsapp&type=pay_now&type=both&type=donation&layout=landing`
      if (this.member.role === 'Agent') {
        url += `&agent_member_id=${this.member.id}&members=${this.member.id}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.forms = response.data.results
        this.totalCount = response.data.count
        this.count = response.data.count
      })
      .catch((error) => {
        if (error.response.data.detail === 'Invalid page.') {
          this.fetchForms(1)
        }
      })
    },
    fetchPublishedFormCount () {
      this.$axios.get(`/companies/${this.company.id}`)
        .then(resp => {
          this.publishedFormCount = resp.data.published_sales_page_form_count
        })
        .catch(() => {})
    },
    clickAddForm () {
       if (this.reachFormCountLimit) {
        this.showMessage(['upgrade'])
        return
      }
      this.showAddWaFormDialog = true
    },
    searchItem (page) {
      this.page = parseInt(page)
      let searchUrl = searchUrl = `/forms/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id&type_exclude=store&layout=landing`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      if (this.member.role === 'Agent') {
        searchUrl += `&agent_member_id=${this.member.id}&members=${this.member.id}`
      }
      this.isFetching = true
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.forms = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    handleDeleteItem (item) {
      this.forms = this.forms.filter((x) => x !== item)
      this.totalCount --
      this.fetchPublishedFormCount()
    },
    handleAddItem (item) {
      this.forms.splice(0, 0, item)
      this.totalCount ++
    },
    handleDuplicateItem (item) {
      this.forms.splice(0, 0, item)
      this.totalCount ++
    },
    handleEditItem (item) {
      let editIndex = 0
      this.forms.forEach((form, index) => {
        if (form.id === item.id) {
          editIndex = index
        }
      })
      this.forms = this.forms.filter((x) => x.id !== item.id)
      this.forms.splice(editIndex, 0, item)
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "create_new_sales_page": "Create new sales page",
    "start_creating_sales_page": "Start Creating Your Sales Page. Convert your leads better.",
    "demo_page_below": "Demo page below",
    "pages_in_progress": "Pages in progress"
  },
  "id": {
    "create_new_sales_page": "Tambah halaman penjualan baru",
    "start_creating_sales_page": "Mulai Membuat Halaman Penjualan",
    "demo_page_below": "Halaman Demo",
    "pages_in_progress": "Dalam persiapan"
  }
}
</i18n>